import Au from 'assets/images/country/au.svg';
import Ca from 'assets/images/country/ca.svg';
import De from 'assets/images/country/de.svg';
import Es from 'assets/images/country/es.svg';
import Fr from 'assets/images/country/fr.svg';
import Gb from 'assets/images/country/gb.svg';
import Us from 'assets/images/country/us.svg';

export const countryList = [
  {
    label: 'aus',
    icon: Au,
    code: 'au',
  },
  {
    label: 'canada',
    icon: Ca,
    code: 'ca',
  },
  {
    label: 'germany',
    icon: De,
    code: 'de',
  },
  {
    label: 'spain',
    icon: Es,
    code: 'es',
  },
  {
    label: 'france',
    icon: Fr,
    code: 'fr',
  },
  {
    label: 'uk',
    icon: Gb,
    code: 'gb',
  },
  {
    label: 'us',
    icon: Us,
    code: 'us',
  },
];
